import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AppRequestContextService } from '../../../app-request-context.service';
import { ApiV1_Product, findActiveCatalogProduct } from '@pedix-workspace/api-v1';

export const productResolverFn: ResolveFn<ApiV1_Product> = (
  routeSnapshot: ActivatedRouteSnapshot,
) => {
  const appRequestContext = inject(AppRequestContextService);

  const { productId = '', categoryId } = routeSnapshot.params;

  return findActiveCatalogProduct(appRequestContext.catalog(), {
    productIdOrSlug: productId,
    categoryIdOrSlug: categoryId,
  });
};
